const activityTypes = [
  { id: 'LOGIN', name: 'Login' },
  { id: 'FILE_ACCESSED', name: 'File Accessed' },
  { id: 'EMAIL', name: 'Email' },
  { id: 'CALL', name: 'Call' },
  { id: 'NOTE', name: 'Note' }
];

const documentAccessTypes = [
  { id: 'VIEWED', name: 'Viewed' },
  { id: 'SAVED', name: 'Saved' },
  { id: 'EMAILED', name: 'Emailed' },
  { id: 'DOWNLOADED', name: 'Downloaded' },
  { id: 'GENERIC', name: 'Generic' }
];
export { activityTypes, documentAccessTypes };
